/**
 * useEvaluationTab Hook
 * URL-based tab state management for the Evaluation Center
 */

import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo, useCallback } from 'react';

export type EvaluationTab = 'scenarios' | 'metrics' | 'suites';

export function useEvaluationTab() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = useMemo<EvaluationTab>(() => {
    const path = location.pathname;
    if (path.includes('/metrics')) return 'metrics';
    if (path.includes('/suites')) return 'suites';
    return 'scenarios';
  }, [location.pathname]);

  const setActiveTab = useCallback((tab: EvaluationTab) => {
    navigate(`/evaluation/${tab}`);
  }, [navigate]);

  return { activeTab, setActiveTab };
}
